import React, { useEffect, useState, useCallback } from 'react';
import feather from 'feather-icons';
import { Link } from 'react-router-dom';
import AddEditAccountModal from '../Modals/AddEditAccountBottomSheet';
import SuccessToast from '../../toast/SuccessToast';
import { getAccountImage } from '../../util/transactionHelper';
import { amountDisplay } from '../../util/helper';
import WarningToast from '../../pages/WarningToast';
import { useLanguage } from '../../context/LanguageContext';

function AccountSection({ accountData, refreshAccounts }) {
    const { t, language } = useLanguage();

    useEffect(() => {
        feather.replace();
    }, [accountData]);

    const [showModal, setShowModal] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [showToastForDelete, setShowToastForDelete] = useState(false);
    // Removed unused error state

    const handleShow = useCallback(() => setShowModal(true), []);
    const handleClose = useCallback(() => setShowModal(false), []);

    const handleAccountAdded = useCallback(() => {
        refreshAccounts();
    }, [refreshAccounts]);

    if (!accountData) return null;

    return (
        <section>
            <div className="custom-container">
                <div className="title">
                    <h2>{t('accountDetails')}</h2>
                    {accountData.length > 0 && <Link to="/accounts">{t('seeAll')}</Link>}
                </div>

                <div className="row g-3">
                    {accountData.map((account) => (
                        <div key={account.id} className="col-md-3 col-6 account-section-box">
                            <Link
                                to={`/account/${account.id}`}
                                style={{ textDecoration: 'none', display: 'block', height: '100%' }}
                            >
                                <div className="modern-account-box">
                                    <div className="d-flex gap-3">
                                        <div className="modern-account-icon">
                                            <img
                                                className="img-fluid"
                                                src={getAccountImage(account.id, account.name)}
                                                alt={account.name}
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="modern-account-details">
                                            <h4
                                                className="modern-account-name"
                                                title={account.name}
                                            >
                                                {account.name}
                                            </h4>
                                            <h5
                                                className={`modern-account-balance ${account?.balance < 0 ? 'text-danger' : ''}`}
                                            >
                                                {amountDisplay(account.balance, language)}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}

                    {accountData.length <= 3 && (
                        <div className="col-md-3 col-6">
                            <div
                                className="modern-account-box add-account-box"
                                onClick={handleShow}
                            >
                                <div className="add-account-icon">
                                    <i
                                        data-feather="plus"
                                        style={{ width: '18px', height: '18px' }}
                                    ></i>
                                </div>
                                <span className="add-account-text">{t('addAccount')}</span>
                            </div>

                            <AddEditAccountModal
                                show={showModal}
                                onClose={handleClose}
                                onAccountAction={handleAccountAdded}
                                showToast={showToast}
                                setShowToast={setShowToast}
                                showToastForDelete={showToastForDelete}
                                setShowToastForDelete={setShowToastForDelete}
                            />

                            {showToast && (
                                <SuccessToast
                                    message={t('accountAdded')}
                                    onClose={() => setShowToast(false)}
                                />
                            )}
                            {showToastForDelete && (
                                <WarningToast
                                    icon={'https://cdn-icons-png.flaticon.com/512/6861/6861362.png'}
                                    message={t('accountDeleted')}
                                    onClose={() => setShowToastForDelete(false)}
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}

export default AccountSection;
